import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";
import * as serviceWorker from "./serviceWorker";

import { ADPThemeProvider } from "styles/SEITheme";

const Application = () => {
  useEffect(() => {
    const titleSuffix = process.env.REACT_APP_TITLE_SUFFIX;
    console.log(`Using env variable title suffix: "${titleSuffix || ''}"`);
    if (titleSuffix === 'DEV') { // do not add suffix on uat, prod, etc.
      document.title = document.title + ` - ${titleSuffix}`;
    }
  }, []);

  return (
    <StrictMode>
      <Auth0Provider
        domain={process.env.REACT_APP_Auth0Domain as string}
        clientId={process.env.REACT_APP_Auth0ClientID as string}
        redirectUri={window.location.origin}
        connection={process.env.REACT_APP_Auth0Connection}
        backendUri={process.env.REACT_APP_BACKEND_API}
        cacheLocation='localstorage'
      >
        <App />
      </Auth0Provider>
    </StrictMode>
  );
};

export default Application;

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <ADPThemeProvider>
    <Application />
  </ADPThemeProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
